<template>
    <!-- Header -->
    <div class="header d-none d-lg-flex">

        <!-- Logo -->
        <div class="header-left active">
            <router-link to="/dashboard/admin-dashboard" class="logo logo-normal">
                <img src="@/assets/img/logo.png" alt="">
            </router-link>
            <router-link to="/dashboard/admin-dashboard" class="logo logo-white">
                <img src="@/assets/img/logo-white.png" alt="">
            </router-link>
            <router-link to="/dashboard/admin-dashboard" class="logo-small">
                <img src="@/assets/img/logo-small.png" alt="">
            </router-link>
            <a id="toggle_btn" href="javascript:void(0);" @click="toggleSidebar">
                <vue-feather type="chevrons-left"></vue-feather>
            </a>
        </div>
        <!-- /Logo -->

        <a id="mobile_btn" class="mobile_btn d-none" href="javascript:void(0);" @click="toggleSidebar1">
            <span class="bar-icon">
                <span></span>
                <span></span>
                <span></span>
            </span>
        </a>

        <!-- Search (Left Side) -->
        <div class="nav-item nav-searchinputs me-auto d-flex align-items-center ms-3">
            <div class="top-nav-search">
                <a href="javascript:void(0);" class="responsive-search">
                    <i class="fa fa-search"></i>
                </a>
                <form action="javascript:void(0);" class="dropdown">
                    <div class="searchinputs" id="dropdownMenuClickable" data-bs-toggle="dropdown"
                        data-bs-auto-close="false">
                        <input type="text" placeholder="Search">
                        <div class="search-addon">
                            <span><vue-feather type="x-circle" class="feather-14"></vue-feather></span>
                        </div>
                    </div>
                    <div class="dropdown-menu search-dropdown" aria-labelledby="dropdownMenuClickable">
                        <div class="search-info">
                            <h6><span><vue-feather type="search" class="feather-16"></vue-feather></span>Recent Searches
                            </h6>
                            <ul class="search-tags">
                                <li><a href="javascript:void(0);">PO #123</a></li>
                                <li><a href="javascript:void(0);">Kios Sukses</a></li>
                            </ul>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- Header Menu (Right Side) -->
        <ul class="nav user-menu">

            <!-- Fullscreen -->
            <li class="nav-item nav-item-box">
                <a href="javascript:void(0);" id="btnFullscreen" @click="initFullScreen">
                    <vue-feather type="maximize"></vue-feather>
                </a>
            </li>

            <!-- Calendar -->
            <li v-if="$hasPermission('ssp', 'orders', 'view')" class="nav-item nav-item-box position-relative">
                <a href="javascript:void(0);" @click="showCalendar = !showCalendar; showCalculator = false">
                    <vue-feather type="calendar"></vue-feather>
                </a>
                <calendar-popup :show="showCalendar" @close="showCalendar = false" />
            </li>

            <!-- Calculator -->
            <li v-if="$hasPermission('ssp', 'orders', 'view')" class="nav-item nav-item-box position-relative">
                <a href="javascript:void(0);" @click="showCalculator = !showCalculator; showCalendar = false">
                    <i class="fa fa-calculator" style="font-size: 18px; color: #67748e;"></i>
                </a>
                <calculator-popup :show="showCalculator" @close="showCalculator = false" />
            </li>
            <li class="nav-item dropdown has-arrow main-drop">
                <a href="javascript:void(0);" class="dropdown-toggle nav-link userset" data-bs-toggle="dropdown">
                    <span class="user-info">
                        <span class="user-letter">
                            <div class="header-avatar-circle">
                                {{ (currentUser?.name || currentUser?.full_name || 'U').charAt(0).toUpperCase() }}
                            </div>
                        </span>
                        <span class="user-detail">
                            <span class="user-name">{{ currentUser ? (currentUser.name || currentUser.full_name) : 'User' }}</span>
                            <span class="user-role">{{ currentUser ? currentUser.email : 'Administrator' }}</span>
                        </span>
                    </span>
                </a>
                <div class="dropdown-menu menu-drop-user">
                    <div class="profilename">
                        <div class="profileset">
                            <span class="user-img">
                                <div class="header-avatar-circle large">
                                    {{ (currentUser?.name || currentUser?.full_name || 'U').charAt(0).toUpperCase() }}
                                </div>
                                <span class="status online"></span>
                            </span>
                            <div class="profilesets">
                                <h6>{{ currentUser ? (currentUser.name || currentUser.full_name) : 'User' }}</h6>
                                <h5>{{ currentUser ? currentUser.email : 'Administrator' }}</h5>
                            </div>
                        </div>
                        <hr class="m-0">
                        <router-link class="dropdown-item" to="/change-password"> <vue-feather class="me-2"
                                type="lock"></vue-feather> Change Password</router-link>
                        <hr class="m-0">
                        <a @click="handleLogout" class="dropdown-item logout pb-0" href="javascript:void(0);">
                            <img src="@/assets/img/icons/log-out.svg" class="me-2" alt="img">Logout
                        </a>
                    </div>
                </div>
            </li>
        </ul>
        <!-- /Header Menu -->

        <!-- Mobile Menu -->
        <div class="dropdown mobile-user-menu">
            <a href="javascript:void(0);" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"
                aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
            <div class="dropdown-menu dropdown-menu-right">
                <router-link class="dropdown-item" to="/change-password">Change Password</router-link>
                <a class="dropdown-item" @click="handleLogout" href="javascript:void(0);">Logout</a>
            </div>
        </div>
        <!-- /Mobile Menu -->
    </div>
    <!-- /Header -->
</template>

<script>
import CalculatorPopup from "@/components/CalculatorPopup.vue";
import CalendarPopup from "@/components/CalendarPopup.vue";
import authService from "@/services/authService";

export default {
    components: {
        CalculatorPopup,
        CalendarPopup
    },
    data() {
        return {
            showCalendar: false,
            showCalculator: false,
            currentUser: null
        };
    },
    mounted() {
        this.initMouseoverListener();
        this.loadUserSession();
    },
    methods: {
        toggleSidebar1() {
            const body = document.body;
            body.classList.toggle("slide-nav");
        },
        toggleSidebar() {
            const body = document.body;
            body.classList.toggle("mini-sidebar");
        },
        initFullScreen() {
            document.body.classList.toggle("fullscreen-enable");
            if (
                !document.fullscreenElement &&
                /* alternative standard method */
                !document.mozFullScreenElement &&
                !document.webkitFullscreenElement
            ) {
                // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        },

        initMouseoverListener() {
            document.addEventListener('mouseover', this.handleMouseover);
        },
        handleMouseover(e) {
            e.stopPropagation();

            const body = document.body;
            const toggleBtn = document.getElementById('toggle_btn');

            if (body.classList.contains('mini-sidebar') && this.isElementVisible(toggleBtn)) {
                const target = e.target.closest('.sidebar, .header-left');

                if (target) {
                    body.classList.add('expand-menu');
                    this.slideDownSubmenu();
                } else {
                    body.classList.remove('expand-menu');
                    this.slideUpSubmenu();
                }

                e.preventDefault();
            }
        },
        isElementVisible(element) {
            return element.offsetWidth > 0 || element.offsetHeight > 0;
        },
        slideDownSubmenu() {
            const subdropPlusUl = document.getElementsByClassName('subdrop');
            for (let i = 0; i < subdropPlusUl.length; i++) {
                const submenu = subdropPlusUl[i].nextElementSibling;
                if (submenu && submenu.tagName.toLowerCase() === 'ul') {
                    submenu.style.display = 'block';
                }
            }
        },
        slideUpSubmenu() {
            const subdropPlusUl = document.getElementsByClassName('subdrop');
            for (let i = 0; i < subdropPlusUl.length; i++) {
                const submenu = subdropPlusUl[i].nextElementSibling;
                if (submenu && submenu.tagName.toLowerCase() === 'ul') {
                    submenu.style.display = 'none';
                }
            }
        },
        loadUserSession() {
          const session = localStorage.getItem('currentUser');
          if (session) {
            this.currentUser = JSON.parse(session);
          }
        },
        handleLogout() {
          authService.logout();
          this.$router.push('/');
        }
    },
    beforeUnmount() {
        document.removeEventListener('mouseover', this.handleMouseover);
    },
};
</script>

<style scoped>
.header-avatar-circle {
    width: 32px;
    height: 32px;
    background: #029147;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 14px;
    box-shadow: 0 2px 5px rgba(2, 145, 71, 0.2);
}

.header-avatar-circle.large {
    width: 45px;
    height: 45px;
    font-size: 18px;
}

.user-info .user-letter {
    background: transparent;
    border: none;
}
</style>